var React = require('react');
var cx = require('classnames');
var _ = require('lodash');
var ControlGroup = require('./control_group');

var label = require('./input_commons').label;

class TextArea extends React.Component {

  constructor (props) {
    super(props);
    this.displayName = 'TextArea';
  }

  render () {
    return (
      <ControlGroup className={this.props.className} style={this.props.style} label={this.props.label} helpBlockText={this.props.helpBlockText}>
        <textarea className={this.props.textareaClass}
                  name={this.props.name}
                  value={this.props.value}
                  defaultValue={this.props.defaultValue}
                  onChange={this.props.onChange}
                  required={this.props.required}
                  placeholder={this.props.placeholder}
                  style={_.merge({ width: '100%' }, this.props.textareaStyle)} />
      </ControlGroup>
    )
  }

}
TextArea.defaultProps = {
  required: false,
  placeholder: null
};

module.exports = TextArea;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/textarea.jsx